import { SalarySensitiveValue } from "@/components/sensitive-value/SalarySensitiveValue.tsx";
import { SensitiveValue } from "@/components/sensitive-value/SensitiveValue.tsx";
import { Stack, Text, Tooltip, TooltipContent, TooltipTrigger } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface CompensationRollupValueProps {
  value: string | null;
  isIncomplete?: boolean | null;
  isEstimated?: boolean | null;
  missingLineTitles?: string[];
  textClassName?: string;
  alwaysVisible?: boolean;
  defaultVisible?: boolean;
  hideToggle?: boolean;
}

export function CompensationRollupValue({
  value,
  isIncomplete,
  isEstimated,
  missingLineTitles = [],
  textClassName,
  alwaysVisible = false,
  defaultVisible,
  hideToggle = false,
}: CompensationRollupValueProps) {
  const { t } = useTranslation();
  const displayValue = value === null ? "-" : `${isEstimated ? "≈ " : ""}${value}`;
  const content = alwaysVisible ? (
    <Text className={textClassName}>{displayValue}</Text>
  ) : defaultVisible !== undefined ? (
    <SensitiveValue
      value={displayValue}
      textClassName={textClassName}
      defaultVisible={defaultVisible}
      hideToggle={hideToggle}
    />
  ) : (
    <SalarySensitiveValue value={displayValue} textClassName={textClassName} />
  );

  if (!isIncomplete && !isEstimated) return content;

  const explanation = isIncomplete
    ? t("core:compensation_rollup_incomplete_description", {
        lines: missingLineTitles.join(", ") || t("core:compensation_rollup_unknown_lines"),
      })
    : t("core:compensation_rollup_estimated_description");

  return (
    <Stack direction={"horizontal"}>
      <Tooltip>
        <TooltipTrigger>
          <div className="border-b border-dashed">{content}</div>
        </TooltipTrigger>
        <TooltipContent>{explanation}</TooltipContent>
      </Tooltip>
    </Stack>
  );
}
